<template>
  <div class="edit-unit-page">

    <!-- Header -->
    <div class="page-header gradient-header animated fadeInDown">
      <h2>Edit Unit</h2>
      <p>Update unit details below</p>
    </div>

    <!-- Form Container -->
    <div class="unit-form animated fadeInUp">

      <!-- Loading Spinner -->
      <div v-if="loading" class="spinner">
        <i class="fas fa-spinner fa-spin"></i> Updating Unit...
      </div>

      <!-- Error Message -->
      <p v-if="error" class="error-message">{{ error }}</p>

      <form v-else @submit.prevent="submitForm">

        <!-- Unit Details -->
        <div class="form-row">
          <div class="form-section gradient-section">
            <div class="form-group">
              <label>Name</label>
              <input v-model="unit.name" type="text" required />
              <small v-if="errors.name" class="error-msg">{{ errors.name[0] }}</small>
            </div>

            <div class="form-group">
              <label>Status</label>
              <select v-model="unit.status">
                <option>Active</option>
                <option>Inactive</option>
              </select>
              <small v-if="errors.status" class="error-msg">{{ errors.status[0] }}</small>
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="form-actions">
          <button type="submit" class="btn btn-gradient" :disabled="loading">
            <span v-if="loading"><i class="fas fa-spinner fa-spin"></i> Updating...</span>
            <span v-else>Update Unit</span>
          </button>
          <button type="button" class="btn btn-secondary" @click="$router.back()">Cancel</button>
        </div>

      </form>
    </div>

  </div>
</template>

<script>
export default {
  name: 'EditUnitComponent',
  props: ['id'],
  data() {
    return {
      unit: { name: '', status: 'Active' },
      loading: false,
      error: null,
      errors: {}
    };
  },
  methods: {
    async fetchUnit() {
      this.loading = true;
      this.error = null;
      try {
        const data = await this.$store.dispatch('units/getUnit', this.id);
        this.unit = data;
      } catch (err) {
        this.error = err.message || 'Failed to load unit data';
      } finally {
        this.loading = false;
      }
    },
    async submitForm() {
      this.loading = true;
      this.error = null;
      this.errors = {};
      try {
        await this.$store.dispatch('units/updateUnit', { id: this.id, ...this.unit });
        this.$router.push({ name: 'Units' });
      } catch (err) {
        if (err.response?.status === 422) {
          this.errors = err.response.data.errors || {};
          this.error = 'Please correct the highlighted errors.';
        } else {
          this.error = err.message || 'Failed to update unit';
        }
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.fetchUnit();
  }
};
</script>

<style scoped>
.edit-unit-page { width: 100%; padding: 20px; background: #f0f2f5; }

/* Header */
.page-header {
  text-align: center;
  color: #fff;
  padding: 25px 15px;
  border-radius: 12px;
  margin-bottom: 20px;
}
.gradient-header { background: linear-gradient(135deg, #6a82fb, #fc5c7d); }

/* Form container */
.unit-form { max-width: 600px; margin: auto; padding: 20px; }

/* Form Row for future expansion */
.form-row { display: flex; flex-wrap: wrap; gap: 20px; margin-bottom: 20px; }
.form-row > .form-section { flex: 1 1 100%; }

/* Form section */
.form-section { padding: 20px; border-radius: 12px; box-shadow: 0 5px 15px rgba(0,0,0,0.05); background: #fff; }

/* Inputs */
.form-group { margin-bottom: 15px; }
label { font-weight: 600; display: block; margin-bottom: 5px; }
input, select {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
  transition: 0.3s;
}
input:focus, select:focus {
  outline: none;
  border-color: #6a82fb;
  box-shadow: 0 0 8px rgba(106,130,251,0.3);
}

/* Error messages */
.error-msg { color: #dc3545; font-size: 0.85em; margin-top: 3px; display: block; }
.error-message { color: #dc3545; font-weight: 600; margin-bottom: 15px; }

/* Buttons */
.form-actions { display: flex; gap: 15px; justify-content: flex-end; margin-top: 25px; }
.btn { padding: 10px 25px; border-radius: 8px; border: none; cursor: pointer; transition: all 0.3s; }
.btn-gradient { background: linear-gradient(135deg, #6a82fb, #fc5c7d); color: #fff; }
.btn-gradient:hover { transform: scale(1.05); box-shadow: 0 6px 15px rgba(0,0,0,0.15); }
.btn-secondary { background: #6c757d; color: #fff; }
.btn-secondary:hover { background: #5a6268; }

/* Spinner */
.spinner {
  text-align: center;
  font-size: 1.1rem;
  color: #6a82fb;
  margin-bottom: 15px;
}
</style>
